import { FunctionComponent, useState } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import styles from './addNewParentDialog.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import UserInput from '@/components/_custom/UserInput/userInput.tsx'

interface AddNewParentProps {
    open: boolean
    handleClose: () => void
    handleAddParent: (parent: string) => void
}

const AddNewParentDialog: FunctionComponent<AddNewParentProps> = ({
    open,
    handleClose,
    handleAddParent
}: AddNewParentProps) => {
    const { t } = useTranslation()

    const [parentName, setParentName] = useState<string>('')

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('addAdult')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.InputContainer}>
                    <UserInput
                        label={t('adultName')}
                        value={parentName}
                        setValue={setParentName}
                        className={styles.Input}
                    />
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type={'add'}
                        onClick={() => handleAddParent(parentName)}
                        className={styles.Button}
                        disabled={parentName === ''}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default AddNewParentDialog
